<template>
  <main class="souhuo_search_bar">
    <span class="back-icon iconfont icon-xiangzuo1" v-show="inputShowed" @click="hideInput"></span>
    <div class="souhuo_search_form" v-show="inputShowed">
      <div class="souhuo_search_box">
        <i class="iconfont icon-sousuo"></i>
        <input
          ref="searchInput"
          class='search_txt'
          maxlength="100"
          :placeholder="searchTig"
          v-model="inputVal"
          @keypress="limitInputLength"
          @keyup.enter="searchSubmit"/>
        <span class="search_clear" @click="clearInput" v-if="inputVal.length > 0">×</span>
      </div>
    </div>
    <span class="souhuo_cancel_btn" v-show="inputShowed" @click="searchSubmit">搜索</span>
    <div class="souhuo_search_label search-label-tmpl" v-show="!inputShowed" @click="entoSearchPage">
      <i class="iconfont icon-sousuo"></i>
      <span class='search_txt'>{{searchTig}}</span>
    </div>
  </main>
</template>

<script>
export default {
  data () {
    return {
      inputVal: '',
      inputEle: ''
    }
  },
  props: {
    searchTig: {
      type: String,
      default: '',
      required: true
    },
    inputShowed: {
      type: Boolean,
      default: true,
      required: true
    },
    searchText: {
      type: String,
      default: ''
    }
  },
  // 自定义聚焦指令
  directives: {
    focus: {
      inserted: function (el) {
        el.focus()
      }
    }
  },
  methods: {
    limitInputLength (e) {
      if (this.inputVal.length > 100) {
        e.preventDefault()
      }
    },
    hideInput () {
      // 取消按钮
      // this.$router.go(-1)
      this.$emit('hideInput')
    },
    clearInput () {
      this.inputVal = ''
    },
    // 搜索
    searchSubmit () {
      this.$refs.searchInput.blur()
      if (!this.inputVal.trim()) {
        this.inputVal = this.searchTig
      }
      // this.$router.push({ name: 'searchResult', query: { search: this.inputVal } })
      this.$emit('searchResult', this.inputVal)
    },
    entoSearchPage () {
      // this.$router.replace({ name: 'searchPage', query: { search: this.searchTig } })
      this.$emit('entoSearch')
    }
  },
  watch: {
    searchText () {
      this.inputVal = this.searchText
    },
    inputVal () {
      if (this.inputVal.length > 100) {
        this.inputVal = this.inputVal.slice(0, 100)
      }
    }
  }
}
</script>

<style scoped>
  .souhuo_search_bar{
    border-top:1px solid #f2f2f2;
    box-shadow: 0 4px 6px 0px rgba(0,0,0,0.04);
    width: 100%;
    box-sizing: border-box;
    padding: 10px;
    overflow: hidden;
    background: #fff;
    z-index:100;
    position: relative;
  }
  .back-icon{
    width: 8%;
    display: block;
    float: left;
    text-align: right;
    height: 30px;
    line-height: 30px;
    transform: rotateZ(180deg);
    font-size: 20px;
    color: #959595;
  }
  .souhuo_search_form{
    border-radius: 15px;
    position: relative;
    width: 75%;
    box-sizing: border-box;
    padding: 0 30px;
    border:1px solid red;
    float: left;
  }
  .souhuo_search_form input{
    line-height: 28px;
    height: 28px;
    width: 100%;
  }
  .souhuo_search_box>i{
    position: absolute;
    top:6px;
    left:8px;
  }
  .souhuo_search_box>.search_clear{
    position: absolute;
    top:8px;
    right: 6px;
    display: inline-block;
    font-size: 14px;
    width: 14px;
    height: 14px;
    line-height: 13px;
    text-align: center;
    background: #bbb;
    border-radius: 50%;
    color:#fff;
  }
  .souhuo_cancel_btn{
    width: 14%;
    display: block;
    float: right;
    text-align: center;
    height: 30px;
    line-height: 30px;
    background: #2C2C2C;
    color: #fff;
    border-radius: 15px;
  }
  .souhuo_search_label{
    border-top:1px solid #f2f2f2;
    box-shadow: 0 4px 6px -1px rgba(0,0,0,0.04);
    width:100%;
    background: #eee;
    height: 28px;
    line-height: 28px;
    border-radius: 4px;
    color:#999;
    box-sizing: border-box;
    padding: 0 15px;
    width: 100%;
  }
  .souhuo_search_label>i{
    margin-right: 4px;
    position: absolute;
  }
  .souhuo_search_label .search_txt{
    display: inline-block;
    width: 100%;
    padding-left: 20px;
    box-sizing: border-box;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
</style>
